



















import { Vue, Component, Watch } from "vue-property-decorator";

// export type TranslateDomainType = 'gen' | 'spd'; // TODO Future
const mainConfig = {
  service: "etrans", // eTranslation widget definition
  user: "Skillgo.io", // User of the translator module, used for statistical purposes only
  dynamicrefresh: true, // Prevenet refreshing the page after translation is ready
  dynamic: true, // Automatically translate new content if changed on page
  domain: "gen", // Translation domain; gen: General; spd: EU formal language
  hidden: false, // fix to override iframe hiding
  languages: {
    source: "en" // Source language is forced to English; if not defined, defaults to page lang as source
  },
  include: "#menu, .main-container, .dashboard", // Translate only the content
  config: {
    live: true, // All pages visited by user will be automatically translated to the selected language
    mode: "sml", // Force default design
    targets: {
      requester: "etranslate-requester", // Override original render target for eTrans button
      receiver: "etranslate-receiver" // Override original render target for eTrans floating message box
    }
  },
  renderAs: {
    link: false,
    icon: false,
    button: true // Rendered as a button only.
  }
};

const iframeConfig = {
  ...mainConfig,
  renderAs: {
    button: false
  }
};

@Component
export default class EtranslateComponent extends Vue {
  private isTranslated: boolean = false;
  private isTranslating: boolean = false;
  public targetLanguage: string = "";
  private eTrans: any = null;
  private mainConfigScript: HTMLScriptElement | null = null;
  private observer: MutationObserver | null = null;
  private iframeListeners: Map<HTMLIFrameElement, EventListener> = new Map();

  mounted() {
    this.mainConfigScript = document.createElement("script");
    this.mainConfigScript.type = "application/json";
    this.mainConfigScript.className = "etranslate-script";

    this.mainConfigScript.textContent = JSON.stringify(mainConfig);

    this.appendConfigScript(
      document,
      this.mainConfigScript,
      "etranslate-container"
    );

    // Load Webtools Smart Loader (SML), only once
    const scriptAlreadyExists = this.getExistingSmartLoaderScript(document);
    if (!scriptAlreadyExists) {
      const script = document.createElement("script");
      script.src = "https://webtools.europa.eu/load.js?spa=1";
      script.defer = true;
      script.type = "text/javascript";
      document.head.appendChild(script);
    }

    const observer = new MutationObserver(() => {
      const iframes = document.querySelectorAll("iframe");
      this.injectEtranslationIntoIframes(iframes);
    });
    observer.observe(document.body, { childList: true, subtree: true });

    this.observer = observer;

    window.addEventListener("wtEtransReady", this.handleEtransReady);
    window.addEventListener("wtTranslationStart", this.handleTranslationStart);
    window.addEventListener("wtTranslationEnd", this.handleTranslationEnd);
    window.addEventListener("wtTranslationAbort", this.handleTranslationAbort);
    window.addEventListener("wtTranslationError", this.handleTranslationError);
  }

  beforeDestroy() {
    window.removeEventListener("wtEtransReady", this.handleEtransReady);
    window.removeEventListener(
      "wtTranslationStart",
      this.handleTranslationStart
    );
    window.removeEventListener("wtTranslationEnd", this.handleTranslationEnd);
    window.removeEventListener(
      "wtTranslationAbort",
      this.handleTranslationAbort
    );
    window.removeEventListener(
      "wtTranslationError",
      this.handleTranslationError
    );

    if (this.observer) {
      this.observer.disconnect();
    }

    this.iframeListeners.forEach((listener, iframe) => {
      iframe.removeEventListener("load", listener);
    });
    this.iframeListeners.clear();
  }

  @Watch("$route.path")
  private() {
    setTimeout(() => {
      if (this.eTrans) {
        this.eTrans.abortTranslation();
        setTimeout(() => {
          this.autoTranslatePage();
        }, 500);
      }
    }, 500);
  }

  appendConfigScript(
    document: Document,
    configScript: HTMLScriptElement,
    containerId: string
  ) {
    const container = document.getElementById(containerId);

    if (container) {
      container.appendChild(configScript);
    } else {
      setTimeout(() => {
        this.appendConfigScript(document, configScript, containerId);
      }, 100);
    }
  }

  getExistingSmartLoaderScript(document: Document): Element | null {
    return document.querySelector(
      "script[src^='https://webtools.europa.eu/load.js']"
    );
  }

  autoTranslatePage() {
    if (this.isTranslated) {
      this.translatePage();
    }
  }

  translatePage() {
    this.eTrans.translate(
      "#menu, .main-container, .dashboard",
      this.targetLanguage
    );
  }

  // Hide the text appearing next to the Translate button
  hideEtransText() {
    const container: HTMLElement | null = document.getElementById(
      "etranslate-container"
    );
    if (container) {
      const spans = container.querySelectorAll("span");
      spans.forEach(span => {
        span.style.display = "none";
      });
    }
  }

  handleEtransReady() {
    const etransButton = document.getElementById("eTransButton");
    if (etransButton) {
      etransButton.classList.remove("wt-ecl-button", "wt-ecl-button--primary");
      etransButton.classList.add("etransbutton", "button", "green");
      etransButton.style.width = "110px";
      etransButton.style.fontFamily = "Squad, Helvetica, sans-serif";
    }
  }

  handleTranslationStart(e: Event): void {
    const target = e.target as any;
    this.eTrans = target.$wt?.etrans;
    this.isTranslating = true;
    setTimeout(() => {
      this.hideAllEtransIframeWidget();
    }, 100);
  }

  handleTranslationEnd(e: Event): void {
    const target = e.target as any;
    this.targetLanguage = target.$wt?.etrans.toLanguage;
    this.isTranslating = false;
    this.isTranslated = true;
    this.hideEtransText();
  }

  handleTranslationAbort(e: Event): void {
    this.isTranslating = false;
  }

  handleTranslationError(e: Event): void {
    this.isTranslating = false;
  }

  // Handling iFrames

  injectEtranslationIntoIframes(iframes: NodeListOf<HTMLIFrameElement>) {
    iframes.forEach((iframe, index) => {
      if (iframe?.contentDocument?.readyState === "complete") {
        this.injectEtranslationIntoIframe(iframe.contentDocument, index);
      } else {
        if (!this.iframeListeners.has(iframe)) {
          const loadListener = () => {
            this.injectEtranslationIntoIframe(iframe.contentDocument, index);
            // this.hideEtransIframeWidgets(iframe.contentDocument)
          };
          iframe.addEventListener("load", loadListener);
          this.iframeListeners.set(iframe, loadListener);
        }
      }
    });
  }

  injectEtranslationIntoIframe(doc: Document | null, index: number) {
    if (doc) {
      try {
        const scriptAlreadyExists = this.getExistingSmartLoaderScript(doc);
        if (!scriptAlreadyExists) {
          const iframeConfigScript = doc.createElement("script");
          iframeConfigScript.type = "application/json";
          iframeConfigScript.className = "etranslate-script";
          iframeConfigScript.textContent = JSON.stringify(iframeConfig);

          const containerId = `etranslate-container-${index}`;
          this.iFrameAppendEtransContainer(doc, containerId);
          this.appendConfigScript(doc, iframeConfigScript, containerId);
          this.iFrameAppendEtransScript(doc);
        }
      } catch (e) {
        console.log(
          "eTranslation cannot access iframe contentDocument due to cross-origin restrictions:",
          e
        );
      }
    }
  }

  iFrameAppendEtransContainer(doc: Document, containerId: string) {
    const container = doc.createElement("div");
    container.id = containerId;
    container.style.display = "none";

    const target = doc.createElement("div");
    target.classList.add("etranslate-target");

    const requester = doc.createElement("div");
    requester.id = "etranslate-requester";
    requester.classList.add("etranslate-requester");

    const receiver = doc.createElement("div");
    receiver.id = "etranslate-receiver";
    receiver.classList.add("etranslate-receiver");

    target.appendChild(requester);
    target.appendChild(receiver);
    container.appendChild(target);
    doc.body.appendChild(container);
  }

  iFrameAppendEtransScript(doc: Document) {
    const script = doc.createElement("script");
    script.src = "https://webtools.europa.eu/load.js?spa=1";
    script.defer = true;
    script.type = "text/javascript";

    doc.head.appendChild(script);
  }

  hideEtransIframeWidgets(doc: Document | null) {
    if (doc) {
      const iframeEtrans = doc.getElementsByClassName(
        "wt-etrans-frame"
      )[0] as HTMLElement;
      const iframeEtransSpacer = doc.getElementsByClassName(
        "wt-etrans-frame-spacer"
      )[0] as HTMLElement;
      if (iframeEtrans && !(iframeEtrans.style.display === "none"))
        iframeEtrans.style.display = "none";
      if (iframeEtransSpacer && !(iframeEtransSpacer.style.display === "none"))
        iframeEtransSpacer.style.display = "none";
    }
  }

  hideAllEtransIframeWidget() {
    const iframes = document.querySelectorAll("iframe");
    iframes.forEach(iframe => {
      this.hideEtransIframeWidgets(iframe.contentDocument);
    });
  }
}
